<script>
export default {
  data() {
    return {
      token: null,
      action: null, // 'accept' or 'deny'
      invite: null,
      loading: true,
      error: null,
      done: false,
      doneMessage: ""
    };
  },
  mounted() {
    this.token = this.$route.params.token;
    this.action = this.$route.params.action;
    this.loadInviteInfo();
  },
  methods: {
    loadInviteInfo() {
      fetch(`/household_invites/${this.token}/info`, {
        headers: { "Accept": "application/json" }
      }).then(res => {
        if (!res.ok) return res.json().then(d => { throw new Error(d.errors?.base?.[0] || "Invitation not found or expired"); });
        return res.json();
      }).then(data => {
        this.invite = data;
        this.loading = false;
      }).catch(e => {
        this.error = e.message;
        this.loading = false;
      });
    },

    acceptInvite() {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
      fetch(`/household_invites/${this.token}/accept`, {
        method: "POST",
        headers: { "Accept": "application/json", "X-CSRF-Token": csrfToken, "X-Requested-With": "XMLHttpRequest" }
      }).then(res => {
        if (!res.ok) return res.json().then(d => { throw new Error(d.errors?.base?.[0] || "Could not accept invitation"); });
        return res.json();
      }).then(() => {
        this.done = true;
        this.doneMessage = "You've joined the household! Redirecting...";
        setTimeout(() => { window.location.href = "/"; }, 2000);
      }).catch(e => {
        this.error = e.message;
      });
    },

    denyInvite() {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
      fetch(`/household_invites/${this.token}/deny`, {
        method: "POST",
        headers: { "Accept": "application/json", "X-CSRF-Token": csrfToken, "X-Requested-With": "XMLHttpRequest" }
      }).then(res => {
        if (!res.ok) return res.json().then(d => { throw new Error(d.errors?.base?.[0] || "Could not deny invitation"); });
        return res.json();
      }).then(() => {
        this.done = true;
        this.doneMessage = "Invitation denied.";
      }).catch(e => {
        this.error = e.message;
      });
    }
  }
};
</script>

<!--Temporary Layout. We can change this if we want mor or less branding or whatever else we decide on-->

<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 p-4">
    <div class="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">

      <!-- Loading -->
      <div v-if="loading" class="text-gray-500">Loading invitation...</div>

      <!-- Error -->
      <div v-else-if="error" class="text-red-600">
        <h2 class="text-xl font-bold mb-2">Oops</h2>
        <p>{{ error }}</p>
      </div>

      <!-- Done -->
      <div v-else-if="done">
        <h2 class="text-xl font-bold text-green-600 mb-2">✓</h2>
        <p>{{ doneMessage }}</p>
      </div>

      <!-- Invite Info -->
      <div v-else>
        <h2 class="text-xl font-bold mb-4">Household Invitation</h2>
        <p class="text-gray-600 mb-2"><strong>{{ invite.inviter_name }}</strong> has invited you to join:</p>
        <p class="text-lg font-semibold mb-1">{{ invite.household_name }}</p>
        <p class="text-sm text-gray-500 mb-6">Role: {{ invite.role }}</p>

        <div v-if="action === 'accept'">
          <button @click="acceptInvite" class="w-full bg-green-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-green-600 transition-colors mb-3">
            Accept Invitation
          </button>
          <p class="text-xs text-gray-400">You'll be moved to this household</p>
        </div>

        <div v-else-if="action === 'deny'">
          <button @click="denyInvite" class="w-full bg-red-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-red-600 transition-colors mb-3">
            Deny Invitation
          </button>
          <p class="text-xs text-gray-400">The inviter will be notified</p>
        </div>

        <div v-else>
          <div class="flex gap-3">
            <button @click="acceptInvite" class="flex-1 bg-green-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-green-600 transition-colors">
              Accept
            </button>
            <button @click="denyInvite" class="flex-1 bg-red-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-red-600 transition-colors">
              Deny
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
